export default "__VITE_ASSET__3b4765b5__"